  <div [id]="swiperContainerId" class="swiper-wrapper">
    <swiper-container #swiper
        init="false"
        [initialSlide]="index"
        mousewheel="true"
        keyboard="true"
        observer="true"
        slidesperView="1"
        spacebetween="10"
        allowtouchmove="true">
      <ng-content></ng-content>
    </swiper-container>
    <div class="swiper-button-next" (click)="changeSlide(1)"></div>
    <div class="swiper-button-prev swiper-button-disabled" (click)="changeSlide(-1)"></div>

  </div>
  